'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createStateStream;

var _most = require('most');

function createStateStream(store) {
  return new _most.Stream({
    run: function run(sink, scheduler) {
      var unsubscribe = store.subscribe(function () {
        sink.event(scheduler.now(), store.getState());
      });

      return {
        dispose: function dispose() {
          return unsubscribe();
        }
      };
    }
  });
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/redux-heat/lib/createStateStream.js
// module id = 308
// module chunks = 0